import { useState } from 'react';
import { AgxCaption, AgxLabel } from '@urbanx/agx-ui-components';
import './Common.scss';

const RPDataDisclaimer = () => {
  const [showDisclaimers, setShowDisclaimers] = useState(false);

  return (
    <>
      <AgxLabel small extraClasses="rpdataDisclaimerLabel">
        Cotality Property Data Disclaimers{' '}
        <span className="showHideDisclaimer" onClick={() => setShowDisclaimers(!showDisclaimers)}>
          {showDisclaimers ? '(Hide)' : '(Show)'}
        </span>
      </AgxLabel>
      {showDisclaimers && (
        <AgxCaption extraClasses="disclaimerText">
          <strong>Australian Copyright Notice:</strong> This publication reproduces materials and
          content owned or licenced by RP Data Pty Ltd trading as Cotality (Cotality) and may
          include data, statistics, estimates, indices, photographs, maps, tools, calculators
          (including their outputs), commentary, reports and other information (Cotality Data). ©
          Copyright 2025. Cotality and its licensors are the sole and exclusive owners of all
          rights, title and interest (including intellectual property rights) subsisting in the
          Cotality Data contained in this publication. All rights reserved.
          <br />
          <br />
          <strong>Cotality General Disclaimer:</strong> The Cotality Data provided in this
          publication is of a general nature and should not be construed as specific advice or
          relied upon in lieu of appropriate professional advice. While Cotality uses commercially
          reasonable efforts to ensure the Cotality Data is current, Cotality does not warrant the
          accuracy, currency or completeness of the Cotality Data and to the full extent permitted
          by law excludes all liability for any loss or damage howsoever arising (including through
          negligence) in connection with the Cotality Data.
        </AgxCaption>
      )}
    </>
  );
};

export default RPDataDisclaimer;
